import { WeekDay } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { DialogBase } from 't4core';

@Component({
    selector: 'editOpenHoursDialog',
    templateUrl: 'editOpenHoursDialog.html',
})
export class EditOpenHoursDialog extends DialogBase {
    public startTime: moment.Moment = moment().startOf('day');
    public endTime: moment.Moment = moment().startOf('day');
    public dayOfWeek: number = -1;
    public specificDate: moment.Moment = moment().startOf('day');

    public weekDay: string;
    public closed: boolean = false;


    constructor(
        public dialogRef: MatDialogRef<EditOpenHoursDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("EditOpenHoursDialog");
      console.log(this.data);

        if (data.startTime) this.startTime = data.startTime;
        if (data.endTime) this.endTime = data.endTime;
        if(data.closed) this.closed = data.closed
        if (data.dayOfWeek && data.dayOfWeek >= 0) {
            this.dayOfWeek = data.dayOfWeek;
          this.specificDate = null;
          this.weekDay = this.getWeekDayName(data.dayOfWeek);
        } else if (data.specificDate) {
            this.specificDate = data.specificDate;
            this.dayOfWeek = -1;
      }

  }
    
  // Get the name of the selected day.
  public getWeekDayName(day: number): string {
    //Have to specifically check for Sunday, since WeekDay is based on us system.
    if (day === 7)
      return WeekDay[WeekDay.Sunday]; 

    return WeekDay[day];
  }

    public async save() {
        await this.Api.post("Location/UpdateOpenHours", null, {
            dayOfWeek: this.dayOfWeek,
            specificDate: this.specificDate ? this.specificDate.toISOString() : null,
            opens: this.startTime.format("YYYY-MM-DDTHH:mm:ss[Z]"),
            closes: this.endTime.format("YYYY-MM-DDTHH:mm:ss[Z]"),
            closed: this.closed,
        });

        this.dialogRef.close(true);
    }
}
